import { render } from "./CoverUpdate.vue?vue&type=template&id=89f811e4&scoped=true"
import script from "./CoverUpdate.vue?vue&type=script&lang=js"
export * from "./CoverUpdate.vue?vue&type=script&lang=js"

import "./CoverUpdate.vue?vue&type=style&index=0&id=89f811e4&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f811e4"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon,QImg,QBtn});
